var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.htmlTag,{tag:"component",class:_vm.cssClass,domProps:{"innerHTML":_vm._s(_vm.linkified)}})}
var staticRenderFns = []

export { render, staticRenderFns }